import { lAsync } from 'app/blocks/common/codes';
import showDialog from 'app/blocks/common/jsx/dialogModal';

async function getLeaveMessage(OpenAccessOrderStepEnum, action, isOrderExists) {
    if (isOrderExists) {
        return lAsync('ORDER_PANELS.POP_UP_CODES.SUBMITTED_ORDER_LEAVE');
    }

    switch (action) {
        case OpenAccessOrderStepEnum.INITIATE:
            return lAsync('ORDER_PANELS.POP_UP_CODES.UNSUBMITTED_ORDER_LEAVE');
        case OpenAccessOrderStepEnum.REVIEW:
            return lAsync('ORDER_PANELS.POP_UP_CODES.UNSUBMITTED_ORDER_REVIEW_LEAVE');
        case OpenAccessOrderStepEnum.PAYMENT:
        default:
            return lAsync('ORDER_PANELS.POP_UP_CODES.SUBMITTED_ORDER_LEAVE');
    }
}

async function confirmLeave(OpenAccessOrderStepEnum, action, isOrderExists, onSaveForLater, isTimeout) {
    if (isTimeout) {
        return true;
    }

    const saveForLaterAvailable =
        !isOrderExists && [OpenAccessOrderStepEnum.INITIATE, OpenAccessOrderStepEnum.REVIEW].includes(action);

    if (
        ![OpenAccessOrderStepEnum.INITIATE, OpenAccessOrderStepEnum.REVIEW, OpenAccessOrderStepEnum.PAYMENT].includes(
            action,
        )
    ) {
        return true;
    }

    const innerContent = await getLeaveMessage(OpenAccessOrderStepEnum, action, isOrderExists);
    const cancelBtnLabel = await lAsync('ORDER_PANELS.POP_UP_CODES.CANCEL_BUTTON_LABEL');
    const confirmBtnLabel = await lAsync('ORDER_PANELS.POP_UP_CODES.CONFIRM_BUTTON_LABEL');

    return new Promise(resolve => {
        showDialog.modal(closeAnd => ({
            type: 'confirmation',
            innerContent,
            cancelBtnLabel,
            confirmBtnLabel,
            onApprove: closeAnd(async () => {
                try {
                    if (saveForLaterAvailable) {
                        await onSaveForLater(false);
                    }

                    resolve(true);
                } catch {
                    resolve(false);
                }
            }),
            onReject: closeAnd(() => resolve(saveForLaterAvailable)),
            onIgnoreButtons: closeAnd(() => resolve(false)),
        }));
    });
}

// eslint-disable-next-line import/prefer-default-export
export { confirmLeave };
